export default __webpack_public_path__ + "static/media/research-ai.6587a1d2.jpg";